import { Injectable } from "@angular/core";
import { TokenModel } from "src/app/models/identification/token.model";

@Injectable({
  providedIn: 'root',
})
export class LocalStorageTokenService {
  private readonly keyStorage = 'user';
  private tokenCache: TokenModel = null;
  private authorizationTokenCache: TokenModel = null;

  getCurrentToken(): TokenModel {
    if (!this.tokenCache) {
      const json: string = window.localStorage.getItem(this.keyStorage);
      if (json) {
        this.tokenCache = JSON.parse(json) as TokenModel;
      }
    }
    return this.tokenCache;
  }

  getCurrentAuthorizationToken(): TokenModel {
    if (!this.authorizationTokenCache) {
      const json: string = window.localStorage.getItem('authorizationToken');
      if (json) {
        this.authorizationTokenCache = JSON.parse(json) as TokenModel;
      }
    }
    return this.authorizationTokenCache;
  }

  setCurrentToken(token: TokenModel): void {
    this.tokenCache = token;
    if (token) {
      window.localStorage.setItem(this.keyStorage, JSON.stringify(token));
    } else {
      window.localStorage.removeItem(this.keyStorage);
    }
  }

  setCurrentAuthorizationToken(token: TokenModel): void {
    this.authorizationTokenCache = token;
    if (token) {
      window.localStorage.setItem('authorizationToken', JSON.stringify(token));
    } else {
      window.localStorage.removeItem('authorizationToken');
    }
  }
}
